import { crypt, decrypt } from '@/helpers/crypt-helper'

export const StorageHelper = {
  setItem: (key: string, value: any) => {
    const encryptedValue = crypt(JSON.stringify(value))
    localStorage.setItem(key, encryptedValue)
  },
  setItemUncrypted: (key: string, value: any) => {
    localStorage.setItem(key, value)
  },
  getItemUncrypted: (key: string, defaultValue: any = []) => {
    return localStorage.getItem(key)
  },

  getItem: (key: string, defaultValue: any = null) => {
    const encryptedValue = localStorage.getItem(key)

    if (!encryptedValue) {
      return defaultValue
    }

    try {
      return JSON.parse(decrypt(encryptedValue as string))
    } catch (e) {
      console.error('Error decrypting localStorage item:', e)
      return defaultValue
    }
  },

  removeItem: (key: string) => {
    localStorage.removeItem(key)
  }
}
